import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';

export const FieldWrapper = props => {
  return <Badge variant="dark" {...props} />;
};

export const ConstantWrapper = props => {
  return <Badge variant="info" {...props} />;
};

export const TableWrapper = props => {
  return <Badge variant="light" style={{ backgroundColor: '#dceeff' }} {...props} />;
};

export const SectionWrapper = props => {
  return <Badge variant="light" style={{ backgroundColor: '#ddd' }} {...props} />;
};

const FieldDescriptor = ({ fieldName, lookup }) => {
  if (!lookup[fieldName] || !lookup[fieldName].label) {
    return <ConstantWrapper key={fieldName}>{fieldName}</ConstantWrapper>;
  }

  const parentId = lookup[fieldName].parentId;
  if (parentId && lookup[parentId]) {
    const key = `${parentId}${fieldName}`;
    if (lookup[parentId].type === 'table') {
      return (
        <div className="badge-group" key={key}>
          <TableWrapper>{lookup[parentId].label || 'T'}</TableWrapper>
          <FieldWrapper>{lookup[fieldName].label}</FieldWrapper>
        </div>
      );
    }

    if (lookup[parentId].type === 'section' && !lookup[parentId].struct) {
      return (
        <div className="badge-group" key={key}>
          <SectionWrapper>{lookup[parentId].label || 'S'}</SectionWrapper>
          <FieldWrapper>{lookup[fieldName].label}</FieldWrapper>
        </div>
      );
    }
  }

  return <FieldWrapper key={fieldName}>{lookup[fieldName].label}</FieldWrapper>;
};

FieldDescriptor.propTypes = {
  fieldName: PropTypes.string,
  lookup: PropTypes.object,
};

export default FieldDescriptor;
